import { c as _c } from "react/compiler-runtime";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";
import Image from "next/image";
import { useCallback, useEffect, useState } from "react";
import { useDeleteEventDocument } from "@/mutations/use-delete-event-document";
import iconError from "public/img/picto-error-red.svg";
import iconSuccess from "public/img/picto-valid-green.svg";
interface DeleteEventDocumentProps {
  clubSlug: string;
  startDate: string;
  onClose: () => void;
  type: string;
}
export const DeleteEventDocument = t0 => {
  const $ = _c(52);
  const {
    clubSlug,
    startDate,
    onClose,
    type
  } = t0;
  const [disabled, setDisabled] = useState(false);
  const {
    mutate: deleteEventDocument,
    isPending,
    error: deleteError,
    isSuccess: deleteSuccess
  } = useDeleteEventDocument();
  let t1;
  if ($[0] !== clubSlug || $[1] !== deleteEventDocument || $[2] !== startDate || $[3] !== type) {
    t1 = () => {
      deleteEventDocument({
        type,
        clubSlug,
        startDate
      });
    };
    $[0] = clubSlug;
    $[1] = deleteEventDocument;
    $[2] = startDate;
    $[3] = type;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleDelete = t1;
  let t2;
  if ($[5] !== onClose) {
    t2 = () => {
      onClose();
    };
    $[5] = onClose;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleCancel = t2;
  let t3;
  let t4;
  if ($[7] !== deleteError || $[8] !== isPending) {
    t3 = () => {
      if (isPending || deleteError) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    };
    t4 = [isPending, deleteError];
    $[7] = deleteError;
    $[8] = isPending;
    $[9] = t3;
    $[10] = t4;
  } else {
    t3 = $[9];
    t4 = $[10];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[11] !== deleteSuccess || $[12] !== handleCancel) {
    t5 = () => {
      if (deleteSuccess) {
        const timer = setTimeout(() => {
          handleCancel();
        }, 2000);
        return () => clearTimeout(timer);
      }
    };
    t6 = [deleteSuccess, handleCancel];
    $[11] = deleteSuccess;
    $[12] = handleCancel;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  useEffect(t5, t6);
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h1 className="text-3xl font-bold">Suppression du compte rendu</h1>;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      backgroundColor: "#fefaf5",
      width: "600px",
      margin: "20px auto",
      display: "flex",
      flexDirection: "column",
      gap: "20px"
    };
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== startDate) {
    t9 = dayjs(startDate).format("DD/MM/YYYY");
    $[17] = startDate;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <span className="font-bold">{t9}</span>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== clubSlug) {
    t11 = <span className="font-bold">{clubSlug}</span>;
    $[21] = clubSlug;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t10 || $[24] !== t11) {
    t12 = <p>Vous êtes sur le point de supprimer le compte rendu de la réunion du{" "}{t10}{" "}du club {t11}.</p>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <p>Êtes vous sûr de vouloir supprimer ce document ?</p>;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== isPending) {
    t14 = isPending && <CircularProgress sx={{
      color: "#EE4540"
    }} />;
    $[27] = isPending;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== deleteError) {
    t15 = deleteError && <div className="flex flex-col items-center"><Image src={iconError} alt="add photo" width={50} height={50} /><p style={{
        color: "red",
        marginTop: "10px"
      }}>Une erreur est survenue. <br /> Le compte rendu n'a pas pu être supprimée.</p></div>;
    $[29] = deleteError;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== deleteSuccess) {
    t16 = deleteSuccess && <div className="flex flex-col items-center"><Image src={iconSuccess} alt="add photo" width={50} height={50} /><p style={{
        color: "#00ba85",
        marginTop: "10px"
      }}>Compte rendu supprimé avec succès.</p></div>;
    $[31] = deleteSuccess;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t14 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className="flex justify-center">{t14}{t15}{t16}</div>;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== handleCancel) {
    t18 = <button className="text-black px-4 py-2 rounded-md border border-black" onClick={handleCancel}>Annuler</button>;
    $[37] = handleCancel;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const t19 = disabled ? "grey" : "#EE4540";
  let t20;
  if ($[39] !== t19) {
    t20 = {
      backgroundColor: t19
    };
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== disabled || $[42] !== handleDelete || $[43] !== t20) {
    t21 = <button className="text-white px-4 py-2 rounded-md" style={t20} onClick={handleDelete} disabled={disabled}>Supprimer</button>;
    $[41] = disabled;
    $[42] = handleDelete;
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t18 || $[46] !== t21) {
    t22 = <div className="flex justify-center gap-10">{t18}{t21}</div>;
    $[45] = t18;
    $[46] = t21;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t12 || $[49] !== t17 || $[50] !== t22) {
    t23 = <div className="text-center">{t7}<div className="flex flex-wrap justify-around gap-4 p-5 w-full" style={t8}>{t12}{t13}{t17}{t22}</div></div>;
    $[48] = t12;
    $[49] = t17;
    $[50] = t22;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  return t23;
};